import { useContext, useState } from "react";
import LandLordContext from "../../../context/landlord/LandLordContext";
import AuthContext from "../../../context/auth/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import { convertCurrencyFormat, haveValue } from "../../../helper/common";
import { Modal } from "react-bootstrap";
import {
  Button,
  Icon,
  InfoList,
  Modal as DsModal,
} from "../../../components/design";
import "./propertyDetails.css";
import workspaceRoleCapabilities, {
  WORKSPACE_ROLES_CAPABILITIES,
} from "../../../Utils/workspaceRoleCapabilities";

const SingleProperty = ({
  property,
  onPropertyAward,
  hideModal,
  setLinkedTenantsPopup,
  loadData,
  setShowIsEditModal,
}) => {
  const { _t } = useTranslator();
  const [show, setShow] = useState(false);
  const [propData, setPropData] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(true);

  const handleClose = () => {
    setShowDetailsModal(true);
    setShow(false);
  };
  const handleShow = () => {
    setShowDetailsModal(false);
    setShow(true);
  };

  const [deleteId, setDeleteId] = useState("");

  const showmodal = (propId) => {
    setDeleteId(propId);
    handleShow();
  };

  const {
    floor_number,
    street_number,
    street,
    flat_number,
    postcode,
    muncipality,
    province,
    staircase,
    area,
    property_reference = null,
    bedrooms,
    washrooms,
    report_rent,
  } = property;
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const landLordContext = useContext(LandLordContext);
  const { deleteProperty, updatePropertyDetails, isParentLL, editProperty } =
    landLordContext;
  const [awardConfirmationModal, setAwardConfirmationModal] = useState(false);

  const deleteMyProperty = async (propertyid) => {
    await deleteProperty(propertyid, user?._id);
    handleClose();
    hideModal();
    await loadData();
  };

  const handleOpenDetails = (property) => {
    setPropData(property);
    setLinkedTenantsPopup(true);
  };

  const awardPropertyHandler = async () => {
    try {
      let propertyId = property._id.toString();
      await updatePropertyDetails(propertyId, {
        is_awarded: property.is_awarded === true ? false : true,
      });

      onPropertyAward(propertyId);
    } catch (error) {
      console.log(error);
    }
  };

  // Shows the value, or nothing so InfoList prints a grey "—"
  const orEmpty = (value) => (haveValue(value) ? value : undefined);

  return (
    <>
      {showDetailsModal && (
        <div className="property-details text-left">
          <div className="property-details__header">
            <h2 className="property-details__title">
              {street} - {street_number}
            </h2>
            <div className="property-details__actions">
              {WORKSPACE_ROLES_CAPABILITIES?.properties?.edit?.includes(
                user?.current_workspace_role
              ) && (
                <Button
                  variant="ghost"
                  size="sm"
                  iconOnly
                  iconStart={<Icon name="edit" />}
                  aria-label={_t("edit")}
                  onClick={() => {
                    hideModal();
                    setShowIsEditModal(true);
                  }}
                />
              )}
              {WORKSPACE_ROLES_CAPABILITIES?.properties?.delete?.includes(
                user?.current_workspace_role
              ) && (
                <Button
                  variant="ghost"
                  size="sm"
                  iconOnly
                  className="property-details__delete"
                  iconStart={<Icon name="trash" />}
                  aria-label={_t("delete")}
                  onClick={() => showmodal(property._id)}
                />
              )}
            </div>
          </div>

          <section className="property-details__section">
            <h3 className="property-details__eyebrow">{_t("location")}</h3>
            <InfoList
              layout="stacked"
              className="property-details__grid"
              items={[
                { label: _t("street"), value: orEmpty(street) },
                { label: _t("number"), value: orEmpty(street_number) },
                { label: _t("stairway"), value: orEmpty(staircase) },
                { label: _t("floorNumber"), value: orEmpty(floor_number) },
                { label: _t("letter"), value: orEmpty(flat_number) },
                { label: _t("municipality"), value: orEmpty(muncipality) },
                { label: _t("postCode"), value: orEmpty(postcode) },
                { label: _t("province"), value: orEmpty(province) },
              ]}
            />
          </section>

          <section className="property-details__section">
            <h3 className="property-details__eyebrow">{_t("details")}</h3>
            <InfoList
              layout="stacked"
              className="property-details__grid property-details__grid--3"
              items={[
                {
                  label: _t("area"),
                  value: haveValue(area) ? `${area} m²` : undefined,
                },
                { label: _t("bedrooms"), value: orEmpty(bedrooms) },
                { label: _t("bathrooms"), value: orEmpty(washrooms) },
              ]}
            />
            {haveValue(property_reference) && (
              <InfoList
                layout="stacked"
                className="property-details__grid property-details__reference"
                items={[
                  {
                    label: _t("propertyReference"),
                    value: property_reference,
                  },
                ]}
              />
            )}
          </section>

          <section className="property-details__section">
            <h3 className="property-details__eyebrow">
              {_t("rentalOverview")}
            </h3>
            <div
              className="property-details__overview"
              onClick={(e) => {
                handleOpenDetails(property);
                hideModal();
              }}
            >
              <InfoList
                layout="stacked"
                className="property-details__grid property-details__grid--3"
                items={[
                  {
                    label: _t("estimatedRent"),
                    value: haveValue(report_rent)
                      ? `€${convertCurrencyFormat(report_rent)} / ${_t("perMonth")}`
                      : undefined,
                  },
                  {
                    label: _t("likedTenants"),
                    value: property?.sharedProfilesCount || 0,
                  },
                  {
                    label: _t("status"),
                    value: (
                      <span
                        className={
                          property?.is_awarded
                            ? ""
                            : "property-details__status--off"
                        }
                      >
                        {property?.is_awarded ? _t("awarded") : _t("unawarded")}
                      </span>
                    ),
                  },
                ]}
              />
              {/* the click goes up to the box, which opens the tenants view */}
              <Button
                variant="ghost"
                size="sm"
                iconOnly
                iconStart={<Icon name="chevronRight" />}
                aria-label={_t("rentalOverview")}
              />
            </div>
          </section>
        </div>
      )}

      <DsModal
        open={show}
        onClose={handleClose}
        size="md"
        align="start"
        title={_t(
          "areYouSureYouWantToDeleteThisPropertyPleaseNoteThatThisActionCannotBeUndone"
        )}
        actions={
          <>
            <Button variant="secondary" size="lg" onClick={handleClose}>
              {_t("no")}
            </Button>
            <Button
              variant="danger"
              size="lg"
              onClick={(e) => deleteMyProperty(deleteId)}
            >
              {_t("yes")}
            </Button>
          </>
        }
      />

      <Modal
        show={awardConfirmationModal}
        className="metermodal "
        centered
        onHide={() => {
          setAwardConfirmationModal(false);
        }}
      >
        <Modal.Body>
          <h4>{_t("areYouSure")}</h4>
          <div className="auth-form">
            <div className="btngroup row100 gridbar">
              <Button
                variant="outline"
                size="lg"
                type="button"
                onClick={() => {
                  setAwardConfirmationModal(false);
                }}
              >
                {_t("no")}
              </Button>
              <Button
                variant="accent"
                size="lg"
                onClick={(e) => awardPropertyHandler()}
              >
                {_t("yes")}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SingleProperty;
